import React, { Key, useEffect, useState } from 'react'
import './Leave.scss'
import { Link } from 'react-router-dom'
import { leaveService } from '../../../../../Services/leaveService'
import Swal from 'sweetalert2'
import { ILeaveRemainingDaysType, leaveType } from '../../../../../Models/leaveType'
import { IsBetweenSixMonthsAndOneYear, IsOneYearOrMore, TableSerialNumber } from 'Helpers'
import { HorizontalLoader, Pagination } from 'Components'
import profileService from 'Services/profileService'
import { EmployeeType } from 'Models'
import { ArrowRightSVG, CircleSVG, DownloadSvg, FilterSvg, SearchSvgMuted } from 'Components/Svgs'
import { useResolvedProfile } from 'Hooks/useResolvedProfile'
import { useForm } from 'react-hook-form'

const Leave = () => {
  const [request, setRequest] = useState(false)
  const [pageNumber, setPageNumber] = useState(1)
  const [loading, setLoading] = useState(false)
  const [leave, setLeave] = useState<leaveType[]>()
  const [leaveLeftDays, setLeaveLeftDays] = useState<ILeaveRemainingDaysType>()
  const [leaveAdmin, setLeaveAdmin] = useState<leaveType[]>()
  // const [profile, setProfile] = useState<EmployeeType>()

  const { register, watch } = useForm()
  const { profile } = useResolvedProfile()
  // console.log('profileService', profile)
  const isLM = profile?.lineManagerId

  // returns true if greater than 6months or less than 1year else false
  const isEmployeeSixMonthsOldOrLessThanAYear = IsBetweenSixMonthsAndOneYear(
    profile?.employmentDate,
  )
  // returns true equals to 1year or greater than 1year else false
  const isEmployeeExactlyAYearOrMoreThanAYear = IsOneYearOrMore(profile?.employmentDate)

  // console.log('isEmployeeSixMonthsOldOrLessThanAYear', isEmployeeSixMonthsOldOrLessThanAYear)
  // console.log('isEmployeeExactlyAYearOrMoreThanAYear', isEmployeeExactlyAYearOrMoreThanAYear)

  const [paginationData, setPaginationData] = useState<{
    pageNumber: number
    pageSize: number
    total: number
  }>({
    pageNumber: 1,
    pageSize: 20,
    total: 1,
  })
  const getLeave = async () => {
    setRequest(true)
    await leaveService.getUserLeave(pageNumber).then(
      (data) => {
        // console.log('user leave', data.data.data.dataset)
        setLeave(data.data.data.dataset)
        setRequest(false)
      },
      (error: { response: { data: { error: string } } }) => {
        // console.log('user leaveService', error)
        setRequest(false)
        Swal.fire({
          icon: 'warning',
          title: 'Oops!',
          text: error.response.data.error,
          showConfirmButton: false,
          timer: 3000,
        })
      },
    )
  }

  useEffect(() => {
    getLeave()
  }, [])

  const getLeaveRemainingDays = async () => {
    setRequest(true)
    await leaveService.getLeaveRemainingDays().then(
      (data) => {
        // console.log('user left days', data?.data?.data)
        setLeaveLeftDays(data?.data?.data)
        setRequest(false)
      },
      (error: { response: { data: { error: string } } }) => {
        // console.log('user left leaveService', error)
        setRequest(false)
        Swal.fire({
          icon: 'warning',
          title: 'Oops!',
          text: error.response.data.error,
          showConfirmButton: false,
          timer: 3000,
        })
      },
    )
  }

  useEffect(() => {
    getLeaveRemainingDays()
  }, [])

  const getAdminLeave = async () => {
    setRequest(true)
    await leaveService.getLineManagerLeave(pageNumber, profile?.id).then(
      (data) => {
        // console.log('admin leave', data.data.data.dataset)
        setLeaveAdmin(data.data.data.dataset)
        setRequest(false)

        setPaginationData({
          pageNumber: data?.data.data.pageNumber,
          pageSize: data?.data.data.pageSize,
          total: data?.data.data.total,
        })
      },
      (error: { response: { data: { error: string } } }) => {
        // console.log('leaveService', error)
        setRequest(false)
        Swal.fire({
          icon: 'warning',
          title: 'Oops!',
          text: error.response.data.error,
          showConfirmButton: false,
          timer: 3000,
        })
      },
    )
  }

  useEffect(() => {
    if (profile) {
      getAdminLeave()
    }
  }, [profile])

  const teamStatus = 'PENDING_APPROVAL'
  const [teamLeave, setTeamLeave] = useState<leaveType[]>()
  const [activeTab, setActiveTab] = useState('')

  const [sortOrder, setSortOrder] = useState('DESC')
  const [status, setStatus] = useState<string>('PENDING_APPROVAL')
  const [hrApprovalStatus, setHrApprovalStatus] = useState<string | undefined>(undefined)

  const handleReset = (e: any) => {
    e.preventDefault()
    setStatus('PENDING_APPROVAL')
    setHrApprovalStatus(undefined)
  }
  const empty = status || hrApprovalStatus

  const employeeName = watch('employeeName')
  const [debouncedEmployeeName, setDebouncedEmployeeName] = useState('')

  const buildSearchParams = (value?: string) => {
    if (!value) return {}
    const trimmed = value.trim()

    if (trimmed.startsWith('EMP_')) {
      return { userId: trimmed }
    }
    if (/^\d+$/.test(trimmed)) {
      return { id: trimmed }
    }
    if (/^[a-zA-Z0-9]+$/.test(trimmed) && trimmed.length > 15) {
      return { id: trimmed }
    }

    return { employeeName: trimmed }
  }

  useEffect(() => {
    const timeout = setTimeout(() => {
      setDebouncedEmployeeName(employeeName || '')
    }, 500)

    return () => clearTimeout(timeout)
  }, [employeeName])

  const getTeamLeave = async () => {
    setRequest(true)
    await leaveService.getTeamLeave(pageNumber, status, sortOrder).then(
      (data) => {
        // console.log('team leave', data.data.data.dataset)
        setTeamLeave(data.data.data.dataset)
        setRequest(false)

        setPaginationData({
          pageNumber: data?.data.data.pageNumber,
          pageSize: data?.data.data.pageSize,
          total: data?.data.data.total,
        })
      },
      (error: { response: { data: { error: string } } }) => {
        // console.log('leaveService', error)
        setRequest(false)
        Swal.fire({
          icon: 'warning',
          title: 'Oops!',
          text: error.response.data.error,
          showConfirmButton: false,
          timer: 3000,
        })
      },
    )
  }

  useEffect(() => {
    if (profile) {
      getTeamLeave()
    }
  }, [profile, status, sortOrder])

  const leaveAction = async (leaveId: string, action: string) => {
    Swal.fire({
      title: 'Alert?',
      text: `Are you sure you want to ${action} this leave?`,
      showDenyButton: true,
      confirmButtonText: 'Yes',
      denyButtonText: 'No',
    }).then(async (result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        Swal.showLoading()
        await leaveService.leaveAction(leaveId, action).then(
          () => {
            getLeave()
            Swal.fire({
              icon: 'success',
              title: 'Done!',
              text: `Leave ${action === 'approve' ? 'approved' : 'rejected'} succesfully!`,
              showConfirmButton: false,
              timer: 3000,
            })
            Swal.hideLoading()
          },
          (error: { response: { data: { error: string } } }) => {
            Swal.hideLoading()
            // console.log('leaveService', error)
            setRequest(false)
            Swal.fire({
              icon: 'warning',
              title: 'Oops!',
              text: error.response.data.error || 'Something went wrong',
              showConfirmButton: false,
              timer: 3000,
            })
          },
        )
      }
    })
  }

  useEffect(() => {
    const handleTabShown = (event: Event) => {
      const tab = event.target as HTMLButtonElement

      if (tab.matches('[data-bs-toggle="pill"]')) {
        setActiveTab(tab.dataset.bsTarget ?? '')
      }
    }

    document.addEventListener('shown.bs.tab', handleTabShown)
    return () => {
      document.removeEventListener('shown.bs.tab', handleTabShown)
    }
  }, [])

  // const getProfile = async () => {
  //   await profileService.profile().then((response) => {
  //     // console.log('profileService', response.data.data)
  //     setProfile(response.data.data)
  //   })
  // }

  // useEffect(() => {
  //   getProfile()
  // }, [])
  return (
    <div className='Leave ms-2 me-md-3'>
      <div className='container'>
        <div className='row mt-4'>
          <div className='col- col-md-4 col-xl-3 custom-col- mb-2'>
            <div className='card border-0 block-list'>
              {leaveLeftDays && (
                <div className={`card-body ${leaveLeftDays?.ANNUAL === 0 ? 'disabled-card' : ''}`}>
                  <div className='title'>Annual Leave</div>
                  <div className='value'>
                    <CircleSVG />
                    <span>{leaveLeftDays?.ANNUAL}</span>
                    <span className='days'>Days Left</span>
                  </div>
                  <Link to='/leave-application/ANNUAL/22' className='action'>
                    Apply now <ArrowRightSVG />
                  </Link>
                </div>
              )}
            </div>
          </div>
          <div className='col- col-md-4 col-xl-3 custom-col- mb-2'>
            <div
              className={`card border-0 block-list ${profile?.gender === 'male' || profile?.gender === 'M' ? 'disabled-card' : ''}`}
              aria-disabled={profile?.gender === 'male' || profile?.gender === 'M'}
            >
              {leaveLeftDays && (
                <div className='card-body'>
                  <div className='title'>Maternity Leave</div>
                  <div className='value'>
                    <svg
                      width='22'
                      height='22'
                      viewBox='0 0 32 32'
                      fill='none'
                      xmlns='http://www.w3.org/2000/svg'
                    >
                      <circle cx='16' cy='16' r='16' fill='#DCD7FE' />
                    </svg>
                    <span>{leaveLeftDays?.MATERNITY}</span>
                    <span className='days'>Days Left</span>
                  </div>
                  <div className='action'>
                    <Link to='/leave-application/MATERNITY/90' className='action'>
                      Apply now{' '}
                      <svg
                        width='12'
                        height='11'
                        viewBox='0 0 12 11'
                        fill='none'
                        xmlns='http://www.w3.org/2000/svg'
                      >
                        <path
                          d='M1.49316 5.5H9.49317'
                          stroke='#FC6FBB'
                          strokeWidth='1.5'
                          strokeLinecap='round'
                          strokeLinejoin='round'
                        />
                        <path
                          d='M6.82617 9.5L10.8262 5.5L6.82617 1.5'
                          stroke='#FC6FBB'
                          strokeWidth='1.5'
                          strokeLinecap='round'
                          strokeLinejoin='round'
                        />
                      </svg>
                    </Link>
                  </div>
                </div>
              )}
            </div>
          </div>
          <div className='col- col-md-4 col-xl-3 custom-col- mb-2'>
            <div
              className={`card border-0 block-list ${profile?.gender === 'female' || profile?.gender === 'F' ? 'disabled-card' : ''}`}
              aria-disabled={profile?.gender === 'female' || profile?.gender === 'F'}
            >
              {leaveLeftDays && (
                <div className='card-body'>
                  <div className='title'>Paternity Leave</div>
                  <div className='value'>
                    <svg
                      width='22'
                      height='22'
                      viewBox='0 0 32 32'
                      fill='none'
                      xmlns='http://www.w3.org/2000/svg'
                    >
                      <circle cx='16' cy='16' r='16' fill='#DCD7FE' />
                    </svg>
                    <span>{leaveLeftDays?.PATERNITY}</span>
                    <span className='days'>Days Left</span>
                  </div>
                  <Link to='/leave-application/PATERNITY/5' className='action'>
                    Apply now{' '}
                    <svg
                      width='12'
                      height='11'
                      viewBox='0 0 12 11'
                      fill='none'
                      xmlns='http://www.w3.org/2000/svg'
                    >
                      <path
                        d='M1.49316 5.5H9.49317'
                        stroke='#FC6FBB'
                        strokeWidth='1.5'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                      />
                      <path
                        d='M6.82617 9.5L10.8262 5.5L6.82617 1.5'
                        stroke='#FC6FBB'
                        strokeWidth='1.5'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                      />
                    </svg>
                  </Link>
                </div>
              )}
            </div>
          </div>
          <div className='col- col-md-4 col-xl-3 custom-col- mb-2'>
            <div className='card border-0 block-list'>
              {leaveLeftDays && (
                <div className='card-body'>
                  <div className='title'>Compassionate Leave</div>
                  <div className='value'>
                    <svg
                      width='22'
                      height='22'
                      viewBox='0 0 32 32'
                      fill='none'
                      xmlns='http://www.w3.org/2000/svg'
                    >
                      <circle cx='16' cy='16' r='16' fill='#DCD7FE' />
                    </svg>
                    <span>{leaveLeftDays?.COMPASSIONATE}</span>
                    <span className='days'>Days Left</span>
                  </div>
                  <Link to='/leave-application/COMPASSIONATE/5' className='action'>
                    Apply now{' '}
                    <svg
                      width='12'
                      height='11'
                      viewBox='0 0 12 11'
                      fill='none'
                      xmlns='http://www.w3.org/2000/svg'
                    >
                      <path
                        d='M1.49316 5.5H9.49317'
                        stroke='#FC6FBB'
                        strokeWidth='1.5'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                      />
                      <path
                        d='M6.82617 9.5L10.8262 5.5L6.82617 1.5'
                        stroke='#FC6FBB'
                        strokeWidth='1.5'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                      />
                    </svg>
                  </Link>
                </div>
              )}
            </div>
          </div>
          <div className='col- col-md-4 col-xl-3 custom-col- mb-2'>
            <div className='card border-0 block-list'>
              {leaveLeftDays && (
                <div className='card-body'>
                  <div className='title'>Sick Leave</div>
                  <div className='value'>
                    <svg
                      width='22'
                      height='22'
                      viewBox='0 0 32 32'
                      fill='none'
                      xmlns='http://www.w3.org/2000/svg'
                    >
                      <circle cx='16' cy='16' r='16' fill='#DCD7FE' />
                    </svg>
                    <span>{leaveLeftDays?.SICK}</span>
                    <span className='days'>Days Left</span>
                  </div>
                  <Link to='/leave-application/SICK/12' className='action'>
                    Apply now{' '}
                    <svg
                      width='12'
                      height='11'
                      viewBox='0 0 12 11'
                      fill='none'
                      xmlns='http://www.w3.org/2000/svg'
                    >
                      <path
                        d='M1.49316 5.5H9.49317'
                        stroke='#FC6FBB'
                        strokeWidth='1.5'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                      />
                      <path
                        d='M6.82617 9.5L10.8262 5.5L6.82617 1.5'
                        stroke='#FC6FBB'
                        strokeWidth='1.5'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                      />
                    </svg>
                  </Link>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      <div className='container mt-4'>
        <div className='card border-0'>
          <div className='card-header  border-0'>
            <div className='row mt-2 leave-tabs'>
              {(leaveAdmin === undefined || leaveAdmin.length === 0) && (
                <div className='col-md-12'>Leave History</div>
              )}
              {/* <div className="col-6 col-md-2 dropdown">
                <button
                  className="btn btn-filter dropdown-toggle"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                  type="button"
                >
                  <svg
                    width="17"
                    height="17"
                    className="me-2"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M2 12C2 8.22876 2 6.34315 3.17157 5.17157C4.34315 4 6.22876 4 10 4H14C17.7712 4 19.6569 4 20.8284 5.17157C22 6.34315 22 8.22876 22 12V14C22 17.7712 22 19.6569 20.8284 20.8284C19.6569 22 17.7712 22 14 22H10C6.22876 22 4.34315 22 3.17157 20.8284C2 19.6569 2 17.7712 2 14V12Z"
                      stroke="#6A80A3"
                      strokeWidth="1.5"
                    />
                    <path
                      d="M7 4V2.5"
                      stroke="#6A80A3"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                    />
                    <path
                      d="M17 4V2.5"
                      stroke="#6A80A3"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                    />
                    <path
                      d="M2.5 9H21.5"
                      stroke="#6A80A3"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                    />
                    <path
                      d="M18 17C18 17.5523 17.5523 18 17 18C16.4477 18 16 17.5523 16 17C16 16.4477 16.4477 16 17 16C17.5523 16 18 16.4477 18 17Z"
                      fill="#6A80A3"
                    />
                    <path
                      d="M18 13C18 13.5523 17.5523 14 17 14C16.4477 14 16 13.5523 16 13C16 12.4477 16.4477 12 17 12C17.5523 12 18 12.4477 18 13Z"
                      fill="#6A80A3"
                    />
                    <path
                      d="M13 17C13 17.5523 12.5523 18 12 18C11.4477 18 11 17.5523 11 17C11 16.4477 11.4477 16 12 16C12.5523 16 13 16.4477 13 17Z"
                      fill="#6A80A3"
                    />
                    <path
                      d="M13 13C13 13.5523 12.5523 14 12 14C11.4477 14 11 13.5523 11 13C11 12.4477 11.4477 12 12 12C12.5523 12 13 12.4477 13 13Z"
                      fill="#6A80A3"
                    />
                    <path
                      d="M8 17C8 17.5523 7.55228 18 7 18C6.44772 18 6 17.5523 6 17C6 16.4477 6.44772 16 7 16C7.55228 16 8 16.4477 8 17Z"
                      fill="#6A80A3"
                    />
                    <path
                      d="M8 13C8 13.5523 7.55228 14 7 14C6.44772 14 6 13.5523 6 13C6 12.4477 6.44772 12 7 12C7.55228 12 8 12.4477 8 13Z"
                      fill="#6A80A3"
                    />
                  </svg>
                  Filter by
                  <svg
                    width="13"
                    height="7"
                    className="ms-3"
                    viewBox="0 0 14 8"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M12.2929 0.292892C12.6834 -0.0976324 13.3166 -0.0976324 13.7071 0.292892C14.0976 0.683416 14.0976 1.31658 13.7071 1.70711L7.70711 7.70711C7.32853 8.08568 6.71894 8.09893 6.32428 7.73715L0.324275 2.23715C-0.0828438 1.86396 -0.110347 1.23139 0.262846 0.824274C0.636039 0.417155 1.26861 0.389652 1.67572 0.762845L6.96992 5.61586L12.2929 0.292892Z"
                      fill="#6A80A3"
                    />
                  </svg>
                </button>
                <ul className="dropdown-menu">
                  <li>
                    <a className="dropdown-item d-none" href="#">
                      Action
                    </a>
                  </li>
                  <li>
                    <a className="dropdown-item d-none" href="#">
                      Another action
                    </a>
                  </li>
                  <li>
                    <a className="dropdown-item d-none" href="#">
                      Something else here
                    </a>
                  </li>
                </ul>
              </div> */}
            </div>
          </div>
          {leaveAdmin && leaveAdmin.length > 0 && (
            <ul
              className={`nav nav-pills ${activeTab === '#pills-team' ? 'mb-3' : ''} px-3`}
              id='pills-tab'
              role='tablist'
            >
              <li className='nav-item' role='presentation'>
                <button
                  className='nav-link active'
                  id='pills-home-tab'
                  data-bs-toggle='pill'
                  data-bs-target='#pills-home'
                  type='button'
                  role='tab'
                  aria-controls='pills-home'
                  aria-selected='true'
                >
                  Leave History
                </button>
              </li>

              <li className='nav-item' role='presentation'>
                <button
                  className='nav-link'
                  id='pills-profile-tab'
                  data-bs-toggle='pill'
                  data-bs-target='#pills-profile'
                  type='button'
                  role='tab'
                  aria-controls='pills-profile'
                  aria-selected='false'
                >
                  Leave Request
                </button>
              </li>
              <li className='nav-item' role='presentation'>
                <button
                  className='nav-link'
                  id='pills-team-tab'
                  data-bs-toggle='pill'
                  data-bs-target='#pills-team'
                  type='button'
                  role='tab'
                  aria-controls='pills-team'
                  aria-selected='false'
                  // onClick={() => setActiveTab('team')}
                >
                  Team History
                </button>
              </li>
            </ul>
          )}

          {activeTab === '#pills-team' && (
            <div className='row mt- search-filter-con'>
              <div className='col-12 col-md-8'>
                <div className='search-field'>
                  <span>
                    <SearchSvgMuted />
                  </span>

                  <input
                    type='text'
                    className='form-control disabled'
                    placeholder='Search Employee Name'
                    {...register('employeeName')}
                  />
                </div>
              </div>
              <div className='col-6 col-md-2 dropdown'>
                <button
                  className='btn btn-filter dropdown-toggle'
                  data-bs-toggle='dropdown'
                  aria-expanded='false'
                >
                  <FilterSvg />
                  Filters
                </button>
                <div className='dropdown-menu dropdown-menu-end border-0 shadow filter-dropdown'>
                  <div className='dropdown-item h-100'>
                    <form action=''>
                      <div className='form-group'>
                        <label htmlFor=''>Sort List</label>
                        <select
                          id=''
                          className='form-control'
                          onChange={(e: any) => {
                            setSortOrder(e.target.value)
                          }}
                        >
                          <option value='DESC'>Descending Order</option>
                          <option value='ASC'>Ascending Order</option>
                        </select>
                      </div>
                      <div className='form-group mt-3'>
                        <label htmlFor=''>Status</label>
                        <select
                          id=''
                          value={status || ''}
                          className='form-control'
                          onChange={(e: any) => {
                            setStatus(e.target.value || undefined)
                          }}
                        >
                          <option disabled value=''>
                            ---select---
                          </option>
                          <option value='PENDING_APPROVAL'>Pending Approval</option>
                          <option value='APPROVED'>Approved</option>
                          <option value='REJECTED'>Rejected</option>
                          <option value='ON_GOING'>On Going</option>
                          <option value='COMPLETED'>Completed</option>
                        </select>
                      </div>
                      {/* <div className='form-group mt-3 d-none'>
                        <label htmlFor=''>Hr Status</label>
                        <select
                          id=''
                          value={hrApprovalStatus || ''}
                          className='form-control'
                          onChange={(e: any) => {
                            setHrApprovalStatus(e.target.value || undefined)
                          }}
                        >
                          <option disabled value=''>
                            ---select---
                          </option>
                          <option value='PENDING_HR_APPROVAL'>Pending Hr Approval</option>
                          <option value='APPROVED'>Approved</option>
                          <option value='REJECTED'>Rejected</option>
                        </select>
                      </div> */}
                      {/* <div className='form-group mt-3'>
                        <label>Leave Date</label>

                        <div className='row'>
                          <div className='col-6'>
                            <label className='small text-muted'>From</label>
                            <input
                              type='date'
                              className='form-control'
                              {...register('leaveDateFrom')}
                            />
                          </div>

                          <div className='col-6'>
                            <label className='small text-muted'>To</label>
                            <input
                              type='date'
                              className='form-control'
                              {...register('leaveDateTo')}
                            />
                          </div>
                        </div>
                      </div> */}

                      <div className='row mt-3'>
                        <div className='col-md-6'>
                          <button disabled={!empty} onClick={handleReset} className='btn btn-reset'>
                            Reset
                          </button>
                        </div>
                        <div className='col-md-6 text-end d-none'>
                          <button className='btn btn-filter'>Filter</button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
              <div className='col-6 col-md-2 dropdown'>
                <button
                  className='btn btn-export dropdown-toggle disabled'
                  data-bs-toggle='dropdown'
                  aria-expanded='false'
                >
                  <DownloadSvg />
                  Export
                </button>

                <ul className='dropdown-menu dropdown-menu-end export-dropdown border-0 shadow'>
                  <li className='dropdown-item'> Export as .pdf</li>
                  <li className='dropdown-item'> Export as .xlsx</li>
                  <li className='dropdown-item'> Export as .doc </li>
                </ul>
              </div>
            </div>
          )}

          <div className='card-body px-0'>
            <div className='tab-content' id='pills-tabContent'>
              <div
                className='tab-pane fade show active'
                id='pills-home'
                role='tabpanel'
                aria-labelledby='pills-home-tab'
              >
                {/* <div className="mx-3 mb-3">Leave History</div> */}
                <div className='table-responsive'>
                  <table className='table'>
                    <thead>
                      <tr>
                        <td className='ps-md-3'>Leave Type</td>
                        <td>Start Date</td>
                        <td>End Date</td>
                        <td>Duration</td>
                        <td>Status</td>
                        <td>Reason</td>
                        <td>Approved By</td>
                      </tr>
                    </thead>
                    <tbody>
                      {leave &&
                        leave.map((le: leaveType, index: Key) => (
                          <tr key={index}>
                            <td className='ps-md-3 text-capitalize'>
                              {le.leaveType.replace(/_/g, ' ')}
                            </td>
                            <td> {le.startDate}</td>
                            <td> {le.endDate}</td>
                            <td> {le.days} days</td>
                            <td>
                              {le.status === 'PENDING_APPROVAL' ? (
                                <span className='pending'>Pending</span>
                              ) : (
                                <span className='status'>{le.status}</span>
                              )}
                            </td>
                            <td>{le.reason} </td>
                            <td> {le.approvedBy ?? '-'}</td>
                          </tr>
                        ))}

                      {leave && leave.length === 0 && !request && (
                        <tr>
                          <td colSpan={7} className='text-center'>
                            No leave found
                          </td>
                        </tr>
                      )}

                      {request && (
                        <tr>
                          <td colSpan={7} className='text-center'>
                            <span className='spinner-border spinner-border-sm'></span>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
              {leaveAdmin && leaveAdmin.length > 0 && (
                <div
                  className='tab-pane fade'
                  id='pills-profile'
                  role='tabpanel'
                  aria-labelledby='pills-profile-tab'
                >
                  {/* <div className="mx-3 mb-3">Leave Request</div> */}
                  <div className='table-responsive'>
                    <table className='table'>
                      <thead>
                        <tr>
                          <td>Employee</td>
                          <td>Leave Type</td>
                          <td>Start Date</td>
                          <td>End Date</td>
                          <td>Duration</td>
                          <td>Reason</td>
                          <td>Status</td>
                          <td></td>
                        </tr>
                      </thead>
                      <tbody>
                        {leaveAdmin &&
                          leaveAdmin.map((data: leaveType, index: Key) => (
                            <tr key={index}>
                              <td>
                                {data.employee.firstName} {data.employee.lastName}
                              </td>
                              <td>{data.leaveType}</td>
                              <td>{data.startDate}</td>
                              <td>{data.endDate}</td>
                              <td>{data.days} days</td>
                              <td>{data.reason}</td>
                              <td>
                                {['PENDING_APPROVAL', 'REJECTED'].includes(data.status) ? (
                                  <span className='pending'>{data.status}</span>
                                ) : (
                                  <span className='status'>{data.status}</span>
                                )}
                              </td>
                              <td className='dropdown option-dropdown'>
                                <button
                                  className='btn border-0 dropdown-toggle'
                                  data-bs-toggle='dropdown'
                                  aria-expanded='false'
                                  data-bs-popper-config='{"strategy":"fixed"}'
                                >
                                  <svg
                                    width='18'
                                    height='18'
                                    viewBox='0 0 18 18'
                                    fill='none'
                                    xmlns='http://www.w3.org/2000/svg'
                                  >
                                    <path
                                      d='M7.49991 8.4705C7.49991 7.72933 8.0955 7.14697 8.82344 7.14697C9.55138 7.14697 10.147 7.74256 10.147 8.4705C10.147 9.19844 9.55138 9.79403 8.82344 9.79403C8.0955 9.79403 7.49991 9.21168 7.49991 8.4705Z'
                                      fill='#707070'
                                    />
                                    <path
                                      d='M7.49991 14.1175C7.49991 13.3763 8.0955 12.7939 8.82344 12.7939C9.55138 12.7939 10.147 13.3895 10.147 14.1175C10.147 14.8454 9.55138 15.441 8.82344 15.441C8.0955 15.441 7.49991 14.8587 7.49991 14.1175Z'
                                      fill='#707070'
                                    />
                                    <path
                                      d='M7.49991 2.82353C7.49991 2.08235 8.0955 1.5 8.82344 1.5C9.55138 1.5 10.147 2.09559 10.147 2.82353C10.147 3.55147 9.55138 4.14706 8.82344 4.14706C8.0955 4.14706 7.49991 3.56471 7.49991 2.82353Z'
                                      fill='#707070'
                                    />
                                  </svg>
                                </button>

                                <ul className='dropdown-menu dropdown-menu-end export-dropdown border-0 shadow'>
                                  <li
                                    className='dropdown-item'
                                    onClick={() => leaveAction(data.id, 'approve')}
                                  >
                                    Approve
                                  </li>
                                  <li
                                    className='dropdown-item text-danger'
                                    onClick={() => leaveAction(data.id, 'reject')}
                                  >
                                    Reject
                                  </li>
                                </ul>
                              </td>
                            </tr>
                          ))}

                        {leaveAdmin && leaveAdmin.length === 0 && !request && (
                          <tr>
                            <td colSpan={7} className='text-center'>
                              No leave found
                            </td>
                          </tr>
                        )}
                        {loading === true && leave === undefined && (
                          <tr>
                            <td colSpan={7} className='text-center'>
                              <HorizontalLoader></HorizontalLoader>
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>

                  {paginationData.total >= paginationData.pageSize && (
                    <div className='pagination w-100 d-flex justify-content-center'>
                      {paginationData.total && (
                        <Pagination
                          className='pagination-bar ps-0'
                          currentPage={Number(paginationData.pageNumber)}
                          totalCount={paginationData.total}
                          pageSize={paginationData.pageSize}
                          onPageChange={(page: React.SetStateAction<number>) => setPageNumber(page)}
                        />
                      )}
                    </div>
                  )}
                </div>
              )}
              {teamLeave && (
                <div
                  className='tab-pane fade'
                  id='pills-team'
                  role='tabpanel'
                  aria-labelledby='pills-team-tab'
                >
                  {/* <div className="mx-3 mb-3">Leave Request</div> */}
                  <div className='table-responsive'>
                    <table className='table'>
                      <thead>
                        <tr>
                          <td>Employee</td>
                          <td>Leave Type</td>
                          <td>Start Date</td>
                          <td>End Date</td>
                          <td>Duration</td>
                          <td>Reason</td>
                          <td>Relieving For</td>
                          <td>Status</td>
                          <td></td>
                        </tr>
                      </thead>
                      <tbody>
                        {teamLeave &&
                          teamLeave.length > 0 &&
                          teamLeave.map((data: leaveType, index: Key) => (
                            <tr key={index}>
                              <td>
                                {data.employee.firstName} {data.employee.lastName}
                              </td>
                              <td>{data.leaveType}</td>
                              <td>{data.startDate}</td>
                              <td>{data.endDate}</td>
                              <td>{data.days} days</td>
                              <td>{data.reason}</td>
                              <td>{data.delegatedFor?.fullName ?? '-'}</td>
                              <td>
                                {['PENDING_APPROVAL', 'REJECTED'].includes(data.status) ? (
                                  <span className='pending'>{data.status}</span>
                                ) : (
                                  <span className='status'>{data.status}</span>
                                )}
                              </td>
                              <td className='dropdown option-dropdown'>
                                <button
                                  className='btn border-0 dropdown-toggle'
                                  data-bs-toggle='dropdown'
                                  aria-expanded='false'
                                  data-bs-popper-config='{"strategy":"fixed"}'
                                >
                                  <svg
                                    width='18'
                                    height='18'
                                    viewBox='0 0 18 18'
                                    fill='none'
                                    xmlns='http://www.w3.org/2000/svg'
                                  >
                                    <path
                                      d='M7.49991 8.4705C7.49991 7.72933 8.0955 7.14697 8.82344 7.14697C9.55138 7.14697 10.147 7.74256 10.147 8.4705C10.147 9.19844 9.55138 9.79403 8.82344 9.79403C8.0955 9.79403 7.49991 9.21168 7.49991 8.4705Z'
                                      fill='#707070'
                                    />
                                    <path
                                      d='M7.49991 14.1175C7.49991 13.3763 8.0955 12.7939 8.82344 12.7939C9.55138 12.7939 10.147 13.3895 10.147 14.1175C10.147 14.8454 9.55138 15.441 8.82344 15.441C8.0955 15.441 7.49991 14.8587 7.49991 14.1175Z'
                                      fill='#707070'
                                    />
                                    <path
                                      d='M7.49991 2.82353C7.49991 2.08235 8.0955 1.5 8.82344 1.5C9.55138 1.5 10.147 2.09559 10.147 2.82353C10.147 3.55147 9.55138 4.14706 8.82344 4.14706C8.0955 4.14706 7.49991 3.56471 7.49991 2.82353Z'
                                      fill='#707070'
                                    />
                                  </svg>
                                </button>

                                <ul className='dropdown-menu dropdown-menu-end export-dropdown border-0 shadow'>
                                  <li
                                    className='dropdown-item'
                                    onClick={() => leaveAction(data.id, 'approve')}
                                  >
                                    Approve
                                  </li>
                                  <li
                                    className='dropdown-item text-danger'
                                    onClick={() => leaveAction(data.id, 'reject')}
                                  >
                                    Reject
                                  </li>
                                </ul>
                              </td>
                            </tr>
                          ))}

                        {teamLeave && teamLeave.length === 0 && !request && (
                          <tr>
                            <td colSpan={7} className='text-center'>
                              No leave found
                            </td>
                          </tr>
                        )}
                        {loading === true && teamLeave === undefined && (
                          <tr>
                            <td colSpan={7} className='text-center'>
                              <HorizontalLoader></HorizontalLoader>
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>

                  {paginationData.total >= paginationData.pageSize && (
                    <div className='pagination w-100 d-flex justify-content-center'>
                      {paginationData.total && (
                        <Pagination
                          className='pagination-bar ps-0'
                          currentPage={Number(paginationData.pageNumber)}
                          totalCount={paginationData.total}
                          pageSize={paginationData.pageSize}
                          onPageChange={(page: React.SetStateAction<number>) => setPageNumber(page)}
                        />
                      )}
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Leave
